import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { api } from "@/lib/api";
import { romeMonth } from "@/lib/marketing";

// Spunta «Invia anche una notifica email ai PA» con disponibilità slot del mese (Europe/Rome).
export const CampaignCheckbox = ({ item, sendAt, checked, onChange, testid = "campaign-email" }) => {
  const month = romeMonth(sendAt || new Date());
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    api.get("/admin/marketing/campaigns", { params: { month } }).then((r) => setUsage(r.data)).catch(() => {});
  }, [month]);

  const executed = item?.campaign?.status === "executed";
  const mine = item?.campaign && item.campaign.month === month;
  const full = usage && usage.available === 0 && !mine;
  const withdrawn = item?.status === "withdrawn";
  const disabled = executed || withdrawn || (full && !checked);

  return (
    <div className="border border-gray-200 rounded-[10px] p-3" data-testid={testid}>
      <label className={`flex items-center gap-2 text-sm font-semibold ${disabled ? "text-gray-400" : "text-[#0A0A0A]"}`}>
        <input type="checkbox" checked={executed || checked} disabled={disabled}
          onChange={(e) => onChange(e.target.checked)} data-testid={`${testid}-checkbox`} />
        <Mail size={14} /> Invia anche una notifica email ai PA
      </label>
      <p className="text-xs text-gray-500 mt-1" data-testid={`${testid}-usage`}>
        {executed ? "Campagna email già inviata per questo contenuto." : withdrawn ? "Contenuto ritirato: nessuna campagna email possibile." : usage
          ? `Campagne email ${month}: ${usage.used} di ${usage.limit} usate.` : "Verifica disponibilità…"}
      </p>
      {full && !executed && (
        <p className="text-xs text-[#B40101] mt-1" data-testid={`${testid}-full`}>
          Le {usage.limit} campagne email del mese sono già occupate: il contenuto può essere pubblicato nella dashboard PA senza email.
        </p>
      )}
    </div>
  );
};
